/**
 * profileRewards handles the scripting for spread the soul
 *
 * TODO: Refactor and get rid of jQuery.
 */
SC.profileRewards = (function () {
  var api = {};

  var init = function () {
    redeemClasses();
    rrAnimateFill();
    copyShareUrl();
  };

  var redeemClasses = function () {
    $('.rewards__redeem').on('click', function (e) {
      e.preventDefault();
      var fillAmount = $('.rewards__yellow-fill').attr('data-fill') < 2;

      $.ajax({
        type: 'post',
        url: '/profile/spreadthesoul/redeem_classes/',
        dataType: 'json',
        success: function (data) {
          if (data.success) {
            if (fillAmount) {
              $('.rewards__yellow-fill').fadeIn();
            }

            $('.rewards__progress').fadeIn();
            $('.rewards__earned-container').fadeOut();
            confirmation(null, 'a class credit has been added to your account! now let\'s ride!');
          }
        },
        error: function () {
          confirmation(null, 'oops! something\'s not right. please try again!');
        }
      });
    });
  };

  var rrAnimateFill = function () {
    var fillAmount = $('.rewards__yellow-fill').attr('data-fill');
    var classesRedeemable = $('.rewards__earned-container').attr('data-classes-redeemable') > 0;
    fillAmount = fillAmount > 2 ? 2 : fillAmount;

    $('.rewards__yellow-fill').animate({
      height: ( fillAmount / 2 * 100) + '%'
    }, 2000, function () {
      if ( classesRedeemable) {
        setTimeout(function () {
          $('.rewards__progress, .rewards__yellow-fill').fadeOut();
          $('.rewards__earned-container').fadeIn();
        }, 1000);
      }
    });
  };

  var copyShareUrl = function () {
    // for rr spread the soul
    $('.rewards__copy__link').on('click', function () {
      var shareInput = $('.rewards__copy__input')[0];
      if (copyToClipboard(shareInput)) {
        $(this).removeClass('not-copied').addClass('background-gray-light');
        $('.rewards__copy__success').show();
        setTimeout(function () {
          $('.rewards__copy__link').addClass('not-copied').removeClass('background-gray-light');
          $('.rewards__copy__success').hide();
        }, 3000);
      } else {
        $('.rewards__copy__link').text('link selected');
        confirmation(undefined, 'manually copy link below');
        selectText(shareInput);
      }
    });

    // for tiu
    $('#share-url').on('click', function () {
      copyToClipboardMsg(document.getElementById('share-target'));
      $('.share-icon.share-url').removeClass('not-copied');
      $('.share-icon.share-url').addClass('copy-background');

      setTimeout(function () {
        $('.share-icon.share-url').addClass('not-copied');
        $('.share-icon.share-url').removeClass('copy-background');
      }, 2000);
    });
  };

  // helper functions
  function copyToClipboardMsg(elem) {
    var succeed = copyToClipboard(elem);

    if (!succeed) {
      confirmation(undefined, 'Copy not supported or blocked. Press Ctrl+c to copy.');
    } else {
      confirmation(undefined, 'URL Copied!<br>');
    }
  }

  function selectText(input) {
    input.focus();
    input.setSelectionRange(0, input.value.length);
  }

  function copyToClipboard(elem) {
    var scrollPositionX = window.pageXOffset;
    var scrollPositionY = window.pageYOffset;

    // create hidden text element, if it doesn't already exist
    var targetId = '_hiddenCopyText_';
    var isInput = elem.tagName === 'INPUT' || elem.tagName === 'TEXTAREA';
    var origSelectionStart;
    var origSelectionEnd;

    if (document.queryCommandEnabled('copy')) {
      return false;
    }

    if (isInput) {
      // can just use the original source element for the selection and copy
      target = elem;
      origSelectionStart = elem.selectionStart;
      origSelectionEnd = elem.selectionEnd;
    } else {
      // must use a temporary form element for the selection and copy
      target = document.getElementById(targetId);
      if (!target) {
        var target = document.createElement('textarea');
        target.style.position = 'absolute';
        target.id = targetId;
        document.body.appendChild(target);
      }
      target.textContent = elem.textContent;
    }

    // select the content
    var currentFocus = document.activeElement;
    target.focus();
    target.setSelectionRange(0, target.value.length);

    // copy the selection
    var succeed = false;
    try {
      succeed = document.execCommand('copy');
    } catch (e) {
      succeed = false;
    }
    // restore original focus
    if (currentFocus && typeof currentFocus.focus === 'function') {
      currentFocus.focus();
      window.scrollTo(scrollPositionX, scrollPositionY);
    }

    if (isInput) {
      // restore prior selection
      elem.setSelectionRange(origSelectionStart, origSelectionEnd);
    } else {
      // clear temporary content
      target.textContent = '';
    }

    return succeed;
  }

  init();
  return api;
})();
